import StateDecorator from '../../../components/utils/state/StateDecorator';
import { DataState, isDataState } from '../../../store/data/state';
import { useAppSelector } from '../../../store/hooks';
import assert from 'assert';
import { forwardRef, LegacyRef } from 'react';
import { useParams } from 'react-router-dom';
import SiteDecorator from '../../sites/utils/SiteDecorator';
import StationList from './StationList';
import { useTranslation } from 'react-i18next';

function FiltredStations(_props: object, ref: LegacyRef<HTMLDivElement>) {
  const { t } = useTranslation('components.stations');
  const { site_id } = useParams<{
    project_id: string;
    site_id: string;
  }>();

  const projects = useAppSelector(
    (state) => state.data_slice.externals.projects
  );
  const project_sites = useAppSelector(
    (state) => state.data_slice.externals.project_sites
  );
  const sites = useAppSelector((state) => state.data_slice.externals.sites);
  const thematics = useAppSelector(
    (state) => state.data_slice.externals.thematics
  );
  const devices = useAppSelector((state) => state.data_slice.externals.devices);

  const device_sites = useAppSelector(
    (state) => state.data_slice.externals.site_devices
  );
  const measure_types = useAppSelector(
    (state) => state.data_slice.externals.measure_types
  );
  const measure_points = useAppSelector(
    (state) => state.data_slice.externals.measure_points
  );
  const device_type_measure_types = useAppSelector(
    (state) => state.data_slice.externals.device_type_measure_types
  );
  const device_types = useAppSelector(
    (state) => state.data_slice.externals.device_types
  );

  return SiteDecorator(ref, () => {
    return StateDecorator(
      [
        projects,
        project_sites,
        sites,
        thematics,
        devices,
        device_sites,
        device_types,
        device_type_measure_types,
        measure_types,
        measure_points,
        device_type_measure_types,
      ],
      ref,
      () => {
        assert(isDataState(projects));
        assert(isDataState(project_sites));
        assert(isDataState(sites));
        assert(isDataState(thematics));
        assert(isDataState(devices));
        assert(isDataState(device_sites));
        assert(isDataState(device_types));
        assert(isDataState(measure_types));
        assert(isDataState(measure_points));
        assert(isDataState(device_type_measure_types));

        if (!site_id)
          return (
            <div>{t("Les données du site n'ont pas pu être récupérées")}</div>
          );

        const site = Object.values(sites.data).find(
          (key) => key.id.toString() === site_id
        );

        if (!site)
          return (
            <div>{t("Les données du site n'ont pas pu être récupérées")}</div>
          );

        // Filter active stations (no end_assignement_date)
        const activeStations: DataState<string, typeof measure_points.data> = {
          ...device_sites,
          data: Object.fromEntries(
            Object.entries(measure_points.data).filter(([, d]) => {
              const endDate = new Date(
                d.device_site?.end_assignement_date!
              ).getTime();
              const nowDate = Date.now();
              const isActive =
                endDate === null || endDate === 0 || endDate > nowDate;
              const isMeteoFrance = d.name?.includes('Météo France');
              return isActive && !isMeteoFrance;
            })
          ),
        };

        // Find free devices: not assigned to an active station & of type 'manual_sensor'
        const freeDevices = Object.values(devices.data).filter(
          (device) =>
            !Object.values(activeStations.data).some(
              (station) => station.device_site?.device_id === device.id
            ) && device.type !== 'webservice'
        );

        return (
          <main ref={ref}>
            <div className="list list-without-scroll">
              <StationList
                freeDevices={freeDevices}
                allDevices={Object.values(devices.data)}
                device_sites={Object.values(device_sites.data)}
                thematics={Object.values(thematics.data)}
                sites={sites}
                deviceTypes={device_types}
                measureTypes={measure_types}
                deviceTypeMeasureTypes={device_type_measure_types}
                siteId={site.id}
                measurePoints={Object.values(activeStations.data)}
              />
            </div>
          </main>
        );
      }
    );
  });
}

export default forwardRef(FiltredStations);
